import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { Card, CardActions, CardContent, CardMedia, Typography, IconButton, Grid, Container, Divider } from '@mui/material'
import EditNoteIcon from '@mui/icons-material/EditNote';
import InsertEmoticonIcon from '@mui/icons-material/InsertEmoticon';
import HorizontalScrollBar from '../components/HorizontalScrollBar'
import { Helmet } from "react-helmet-async";

const ArticlesList = () => {
  let [ articles, setArticles ] = useState([])
  let [ socios, setSocios ] = useState([])
  let [ economys, setEconomys ] = useState([])
  let [ governances, setGovernances ] = useState([])

  const backend = 'https://oureclecticsociety.org/core'
  const frontend = 'https://oureclecticsociety.com/'

  let getSocio = async () => {
    let response = await fetch(`${backend}/category_socio/`)
    let data = await response.json()
    setSocios(data)
  }

  let getEconomy = async () => {
    let response = await fetch(`${backend}/category_economy/`)
    let data = await response.json()
    setEconomys(data)
  }

  let getGovernance = async () => {
    let response = await fetch(`${backend}/category_governance/`)
    let data = await response.json()
    setGovernances(data)
  }

  let getArticle = async () => {
    let response = await fetch(`${backend}/articles/`)
    let data = await response.json()
    setArticles(data)
  }

  
  useEffect(() => {
    getGovernance()
    getEconomy()
    getSocio()
    getArticle()
  }, [])

  let me = () => {

    const link = `/article/${articles[articles.length-1].id}`

    return (
      <div>

      <Helmet>
        <title>OES | Articles</title>
        <meta name="description"
          content="A selection of discussions on African politics,
          culture, economy and growth"
        />
        <meta
          name="keywords"
          content="African, Nairobi, Growth, Economy, Culture, History, Politics, Society, Eclectic"
        />
        <meta property="og:title" content="Our Eclectic Society" />
        <meta property="og:description" content="Mindful thoughts and discussions about our continent" />
        {/* <meta property="og:image" content={img1} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" /> */}
        <link rel="canonical" href="/articles" />
      </Helmet>

        <Container>
          <Grid container spacing={8} sx={{ mt: 3, mb: 3}}>
            <Grid xs={12} md={6} sx={{ paddingLeft: 8}}>
                <Typography className='article' variant= 'h3' sx={{ mt: 8, mb: 3}}>{articles[articles.length-1].title}</Typography>
                <Typography variant= 'subtitle1'>
                  {articles[articles.length-1].body.slice(0, 1000)}...
                  <Link to={link}><Typography>read more</Typography></Link>
                </Typography>
            </Grid>
            <Grid xs={12} md={6} sx={{ mt: 5}}>
              {/* <img style={{ width: 450, height: 550, marginLeft: 15, }} src= {`http://127.0.0.1:8000${articles[articles.length-1].image}`}/> */}
              <img style={{ width: 450, height: 550, marginLeft: 15, }}
                src= {`https://res.cloudinary.com/dl0hql4ku/${articles[articles.length-1].image}`}
              />
            </Grid>
          </Grid>
        </Container>

        <Divider sx={{ bgcolor: "black", mt: 5 }} />
        <div className='title'>
          <Typography className='welcome' variant='h2' sx={{ py: 3}}>Socio-Cultural</Typography>
        </div>
        <Divider sx={{ bgcolor: "black", mb: 5 }}/>

        <div>
          {socios.map( (socio, index) => {

            const articleId = socio.id
            
            const socio_link = `${frontend}/article/${articleId}`

            return (
              <div key={index} socio={socio} >

                <Card sx={{ maxWidth: 400, m: 1 }} >
                  <CardMedia
                    sx={{ height: 300 }}
                    image= {`https://res.cloudinary.com/dl0hql4ku/${socio.image}`}
                    title="our eclectic society"
                  />
                  <CardContent>
                    <Typography className='article' gutterBottom variant="h5" component="div">
                      {socio.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {socio.excerpt}...<Link to= {socio_link} ><Typography>read more</Typography></Link>
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <IconButton sx={{color:'grey'}} >
                      <EditNoteIcon />
                      <Typography>Comment</Typography>
                    </IconButton>
                    <IconButton sx={{color:'orange'}} >
                      <InsertEmoticonIcon />
                      <Typography>Like</Typography>
                    </IconButton>
                  </CardActions>
                </Card>
              </div>
            )
          } )}
        </div>

        <Divider sx={{ bgcolor: "black", mt: 5}} />
        <div className='title'>
          <Typography  className='welcome' variant='h2' sx={{ py: 3}}>Economy</Typography>
        </div>
        <Divider sx={{ bgcolor: "black", mb: 5 }}/>

        <div>
          
          <HorizontalScrollBar articles={economys}/>

          {/*economys.map( (economy, index) => {

            const articleId = economy.id

            const economy_link = `http://127.0.0.1:3000/article/${articleId}`

            return (
              <div key={index} economy={economy} >
                <Card sx={{ maxWidth: 345, m: 1 }} >
                  <CardMedia
                    sx={{ height: 300 }}
                    image= {`http://127.0.0.1:8000${economy.image}`}
                    title="our eclectic society"
                  />
                  <CardContent>
                    <Typography gutterBottom variant="h5" component="div">
                      {economy.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {economy.excerpt}...<Link to={economy_link}><Typography>read more</Typography></Link>
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <IconButton sx={{color:'grey'}} >
                      <EditNoteIcon />
                      <Typography>Comment</Typography>
                    </IconButton>
                    <IconButton sx={{color:'orange'}} >
                      <InsertEmoticonIcon />
                      <Typography>Like</Typography>
                    </IconButton>
                  </CardActions>
                </Card>
              </div>
            )
          })*/}
        </div>
        
        <Divider sx={{ bgcolor: "black", mt: 5 }} />
        <div className='title'>
          <Typography  className='welcome' variant='h2'  sx={{ py: 3}}>Governance</Typography>
        </div>
        <Divider sx={{ bgcolor: "black", mb: 5 }}/>

        <div>
          {governances.map( (governance, index) => {

            const articleId = governance.id

            const governance_link = `${frontend}/article/${articleId}`

            return (
              <div key={index} governance={governance} >
                <Card sx={{ maxWidth: 400, m: 1 }} >
                  <CardMedia
                    sx={{ height: 300 }}
                    image= {`https://res.cloudinary.com/dl0hql4ku/${governance.image}`}
                    title="our eclectic society"
                  />
                  <CardContent>
                    <Typography className='article' gutterBottom variant="h5" component="div">
                      {governance.title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {governance.excerpt}...<Link to={governance_link}><Typography>read more</Typography></Link>
                    </Typography>
                  </CardContent>
                  <CardActions>
                    <IconButton sx={{color:'grey'}} >
                      <EditNoteIcon />
                      <Typography>Comment</Typography>
                    </IconButton>
                    <IconButton sx={{color:'orange'}} >
                      <InsertEmoticonIcon />
                      <Typography>Like</Typography>
                    </IconButton>
                  </CardActions>
                </Card>
              </div>
            )
          } )}
        </div>
      </div>
    )
  }


  let rer = () => {
    if (articles.length > 0) {
      return me()
    }
    return <div>Loading....</div>
  }

  return (  rer() )
}

export default ArticlesList
